import styled, { css } from 'styled-components';

import { Flexbox, NextImage } from '@seuk/design-system/atoms';
import { TextField, Button } from '@seuk/design-system/molecules';

export const ArticlesFinderContainer = styled.section`
  margin: ${({ theme }) => theme.spacing(20)} 0;
`;

export const Form = styled(Flexbox)`
  flex-wrap: wrap;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing(6)};
  align-items: end;
  margin-bottom: ${({ theme }) => theme.spacing(8)};
`;

export const SearchField = styled(TextField)`
  flex: 1;
`;

export const CategoriesContainer = styled(Flexbox)`
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing(6)};
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing(8)};

  ${Button} {
    white-space: nowrap;
    ${({ theme }) => theme.typography.paragraph.small.normal};
    font-weight: normal;
  }
`;

export const BannerImg = styled.div`
  ${({ theme }) => css`
    width: 100%;
    margin-bottom: ${theme.spacing(6)};
    position: relative;
    overflow: hidden;
    height: ${theme.spacing(100)};
    border-radius: ${theme.radius};
  `}
`;

export const BannerTitle = styled.a`
  ${({ theme }) => css`
    padding: 0;
    ${theme.typography.heading[3].demi}
    color: ${theme.palette.text.onSurface.link};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  `}
`;

export const BannerInfo = styled.div`
  ${({ theme }) => css`
    top: 0;
    left: 0;
    bottom: 0;
    position: absolute;
    width: ${theme.spacing(100)};
    margin: ${theme.spacing(8)};
    padding: ${theme.spacing(8)};
    background-color: ${theme.palette.background.surface};
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;

    ${theme.breakpoints.down('sm')} {
      width: auto;
    }
  `}
`;

export const StyledImage = styled(NextImage)`
  width: 100%;
  height: auto;
`;

export const SearchClearButton = styled(Button)`
  border-width: 2px;
`;

export const CategoryButton = styled.button<{ active: boolean }>`
  ${({ theme, active }) => css`
    ${theme.typography.label.large.bold}
    color:  ${active ? theme.palette.text.onFocus.strong : theme.palette.text.onBase.link};
    border: 2px solid ${theme.palette.text.onBase.link};
    background-color: ${active ? theme.palette.text.onBase.link : theme.palette.background.surface};
    padding: ${theme.spacing(4)} ${theme.spacing(6)};
    border-radius: ${theme.radius};
    font-size: 1rem;
  `}
`;

export const Pagination = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    margin-top: ${theme.spacing(12)};

    & > ul {
      display: flex;
      justify-content: space-between;
      align-items: center;
      list-style: none;
      padding: 0;
      border-left: 1px solid ${theme.palette.border.medium};
    }
  `}
`;

const navigationAndItemsStyles = css`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    border: 1px solid ${theme.palette.border.medium};
    border-left: none;
    width: ${theme.spacing(12)};
    height: ${theme.spacing(12)};
    padding: ${theme.spacing(3.5)};
    ${theme.typography.label.medium.bold}
  `}
`;

export const PaginationItem = styled.li<{ active?: boolean }>`
  ${({ theme, active }) => css`
    ${navigationAndItemsStyles}
    cursor: default;
    color: ${active ? theme.palette.text.onFocus.strong : theme.palette.text.onSurface.strong};
    background-color: ${active ? theme.palette.focus.strong : theme.palette.background.surface};

    ${!active &&
    css`
      &:hover {
        cursor: pointer;
        background-color: ${theme.palette.focus.extraSubtle};
        color: ${theme.palette.text.onSurface.strong};
      }
    `}
  `};
`;

export const PaginationNavigation = styled.li<{ disabled?: boolean }>`
  ${({ theme, disabled }) => css`
    ${navigationAndItemsStyles}
    cursor: ${disabled ? 'default' : 'pointer'};
    background-color: ${disabled ? theme.palette.background.inactive : theme.palette.background.surface};
  `};
`;
